import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const PetSitting = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my pet sitting business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps pet sitting businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for pet sitting businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most pet sitting businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my pet sitting business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like pet sitting. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Pet Sitting - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Pet Sitting CRM", url: "/industries/pet-sitting" }
  ];

  const industryData = {
    name: 'Pet Sitting & Dog Walking',
    title: 'Build Recurring Client Base & Fill Your Daily Schedule',
    subtitle: 'Automate booking, send daily photo updates, and turn one-time sits into regular recurring clients',
    icon: '🐕',
    challenges: [
      'Hard to fill weekday dog walking slots',
      'One-time vacation sits don\'t become regulars',
      'Clients want constant updates',
      'Last-minute cancellations leave gaps',
      'Difficult to manage multiple pet parents'
    ],
    solutions: [
      'Recurring walk schedule automation',
      'First-time to regular conversion campaigns',
      'Automated daily photo/update system',
      'Cancellation waitlist management',
      'Multi-pet family coordination'
    ],
    features: [
      'Client CRM with pet profiles',
      'Recurring service scheduling',
      'Daily photo update automation',
      'GPS walk tracking',
      'Emergency contact management',
      'Medication reminder tracking',
      'Online booking',
      'Review requests'
    ],
    results: [
      '80% vacation clients become regulars',
      'Fill 95% of walking slots',
      '90% client satisfaction',
      '£3.6K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Pet Sitting UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for pet sitting businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for pet sitting UK, pet sitting business software, pet sitting customer management, pet sitting lead generation UK"
        url="/industries/pet-sitting"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default PetSitting;